import { getDevicesList, deleteDevice, getDevice, updateDevice } from "../../utils/apiClient";

/**
 * Fetch the list of devices connected to the current account.
 * Mirrors Flutter ActiveDeviceScreen._loadingData().
 *
 * @returns {Promise<{ devices: Array, isOwner: boolean }>}
 */
export const fetchDevices = async () => {
  const response = await getDevicesList();
  const data = response?.decryptedData ?? response?.data;

  if (!data) return { devices: [], isOwner: false };

  return {
    code: data.CODE,
    isOwner: data.IS_OWNER === 1,
    devices: Array.isArray(data.DATA) ? data.DATA : [],
  };
};

/**
 * Remove a device from the account.
 * Mirrors Flutter ActiveDeviceScreen._deleteDevice().
 *
 * @param {number|string} deviceId
 * @returns {Promise<any>}
 */
export const removeDevice = async (deviceId) => {
  const response = await deleteDevice(deviceId);
  return response?.decryptedData ?? response?.data;
};

/**
 * Get a single device details by ID.
 * Mirrors Flutter EditDeviceScreen._loadingData().
 *
 * @param {number|string} deviceId
 * @returns {Promise<{ code: number, isOwner: boolean, device: object | null }>}
 */
export const fetchDeviceDetails = async (deviceId) => {
  const response = await getDevice(deviceId);
  const data = response?.decryptedData ?? response?.data;

  if (!data) return { code: null, isOwner: false, device: null };

  return {
    code: data.CODE,
    isOwner: data.IS_OWNER === 1,
    device: data.DATA ?? null,
  };
};

/**
 * Update a device settings.
 * Mirrors Flutter EditDeviceScreen._saveDeviceSettings().
 *
 * @param {object} payload
 * @returns {Promise<any>}
 */
export const saveDeviceSettings = async (payload) => {
  const response = await updateDevice(payload);
  return response?.decryptedData ?? response?.data;
};

export default { fetchDevices, removeDevice, fetchDeviceDetails, saveDeviceSettings };
